import { userDelete } from "@/api";
import { USER_DETAILS_QUERY_KEY } from "@/lib/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const result = await userDelete();
      if (result.err) {
        console.error(result.val.devMessage);
        toast.error("Error al eliminar el usuario", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }

      toast.success("Usuario eliminado exitosamente", {
        description: result.val,
      });

      queryClient.invalidateQueries({
        queryKey: [USER_DETAILS_QUERY_KEY],
      });

      return result.val;
    },
  });
}
